import React from "react";
import { SOLUTIONS_OVERVIEW } from "../data/content";
import Icon from "./Icon";
import "../styles/solutions.css";

function SolutionsList() {
  return (
    <div className="solutions-list">
      {SOLUTIONS_OVERVIEW.map((item) => (
        <div className="solutions-row" key={item.problem}>
          <div className="solutions-problem">
            <span className="solutions-label">Problem</span>
            <p>{item.problem}</p>
          </div>
          <Icon name="arrow" size={20} className="solutions-arrow" />
          <div className="solutions-solution">
            <span className="solutions-label solutions-label--solved">
              Solved by MPeoples HRMS
            </span>
            <p>{item.solution}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SolutionsList;
